export interface ILinkProtocol {
  protocolNumber: string;
}

export enum ITypesRequired {
  LOGISTICA = 'LOGÍSTICA',
  FINANCEIRO = 'FINANCEIRO',
  DEVOLUCAO = 'DEVOLUÇÃO',
  CADASTRO_FICHA_CLIENTE = 'CADASTRO DA FICHA DO CLIENTE',
  COMPENSACAO_NOTA_CREDITO = 'COMPENSAÇÃO DE NOTA DE CRÉDITO',
  RECLAMACAO_TECNICA = 'RECLAMAÇÃO TÉCNICA',
  SOLICITACAO_DE_INFORMACAO_SERVICO = 'SOLICITAÇÃO DE INFORMAÇÃO/SERVIÇO',
  CARTA_TROCA = 'CARTA DE TROCA',
}

export const FileTypesAccept = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf',
  'video/mpeg',
  'video/ogg',
  'video/avi',
  'video/webm',
  'video/3gpp',
  'video/3gpp2',
  'video/mp4',
  'video/wmv',
  'video/flv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel'
];

export const MessagesError = {
  CNPJ: "CNPJ informado é inválido",
  CPF: "CPF informado é inválido",
  DEFAULT: "Ocorreu um erro durante a requisição"
};

export const phaseToEditProtocol = [
  'análise do protocolo',
  'aceite da solicitação',
  'avaliação logística reversa',
  'classificação do protocolo'
];

export const phaseToEditProtocolSimple = [
  'análise do protocolo',
  'aceite da solicitação',
  'avaliação comercial'
];

export const phaseToEditProtocolMissingVolume = [
  'classificação do protocolo',
  'avaliação qualidade extravio'
];

export const hideClientTypeProtocolCategories = [
  'OCORRÊNCIA TRANSPORTADORA'
];

export const hideEmployeeProtocolCategories = [
  'OCORRÊNCIA TRANSPORTADORA'
];